import { useState } from "react";
import { useBudget } from "../context/BudgetContext";

export default function Categories() {
  const { categories, addCategory, deleteCategory, updateCategoryLimit, getCategorySpending, budgetLoading } = useBudget();
  const [newName, setNewName] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editLimit, setEditLimit] = useState("");
  const [confirmId, setConfirmId] = useState(null);

  if (budgetLoading) return <div className="page-loading" />;

  const handleAdd = () => {
    if (!newName.trim()) return;
    addCategory(newName.trim()); setNewName("");
  };

  const handleSave = (id) => {
    updateCategoryLimit(id, Number(editLimit)); setEditingId(null); setEditLimit("");
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Categories</div>
          <div className="page-subtitle">{categories.length} configured</div>
        </div>
      </div>

      <div className="card hover-green" style={{ marginBottom: 10 }}>
        <div className="label" style={{ marginBottom: 8 }}>NEW_CATEGORY</div>
        <div style={{ display: "flex", gap: 6 }}>
          <input placeholder="e.g. groceries" value={newName} onChange={e => setNewName(e.target.value)} onKeyDown={e => e.key === "Enter" && handleAdd()} />
          <button className="btn btn-green" onClick={handleAdd}>+ add</button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 8 }}>
        {categories.map(cat => {
          const spent = getCategorySpending(cat.id);
          const pct = cat.limit > 0 ? Math.min((spent / cat.limit) * 100, 100) : 0;
          const fillClass = pct >= 100 ? "red" : pct >= 75 ? "amber" : "";
          const hoverClass = pct >= 100 ? "hover-red" : pct >= 75 ? "hover-amber" : "hover-green";

          return (
            <div key={cat.id} className={`card ${hoverClass}`}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
                <span className="mono" style={{ fontSize: 12, color: "#888" }}>{cat.name}</span>
                {confirmId === cat.id ? (
                  <div style={{ display: "flex", gap: 4 }}>
                    <button className="btn btn-danger" onClick={() => { deleteCategory(cat.id); setConfirmId(null); }} style={{ padding: "2px 7px", fontSize: 9 }}>sure?</button>
                    <button className="btn" onClick={() => setConfirmId(null)} style={{ padding: "2px 5px", fontSize: 9 }}>✕</button>
                  </div>
                ) : (
                  <button className="btn btn-danger" onClick={() => setConfirmId(cat.id)} style={{ padding: "2px 7px", fontSize: 9 }}>del</button>
                )}
              </div>

              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                <span className="label" style={{ marginBottom: 0 }}>spent</span>
                <span className="mono" style={{ fontSize: 10, color: "#777" }}>
                  ${spent.toLocaleString()}{cat.limit > 0 ? ` / $${cat.limit.toLocaleString()}` : ""}
                </span>
              </div>
              {cat.limit > 0 && (
                <div className="progress-track" style={{ marginBottom: 10 }}>
                  <div className={`progress-fill ${fillClass}`} style={{ width: `${pct}%` }} />
                </div>
              )}

              {editingId === cat.id ? (
                <div style={{ display: "flex", gap: 5 }}>
                  <input type="number" placeholder="limit ($)" value={editLimit} onChange={e => setEditLimit(e.target.value)} autoFocus />
                  <button className="btn btn-green" onClick={() => handleSave(cat.id)} style={{ padding: "5px 10px" }}>save</button>
                  <button className="btn" onClick={() => setEditingId(null)} style={{ padding: "5px 8px" }}>✕</button>
                </div>
              ) : (
                <button className="btn" style={{ width: "100%", fontSize: 10 }}
                  onClick={() => { setEditingId(cat.id); setEditLimit(cat.limit || ""); }}>
                  {cat.limit > 0 ? `edit limit — $${cat.limit.toLocaleString()}` : "set limit"}
                </button>
              )}
            </div>
          );
        })}
      </div>

      {categories.length === 0 && (
        <div style={{ textAlign: "center", padding: 40 }}>
          <span className="mono" style={{ fontSize: 11, color: "#555" }}>no categories — add one above</span>
        </div>
      )}
    </div>
  );
}